import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import LongText from '../../common/Question/LongText';
import FillinLong from '../../common/Question/FillinLong';
import InputSingleLine from './InputSingleLine';
var FormItem = _Form.Item;
var LongTextPC = /*#__PURE__*/function (_Component) {
  _inherits(LongTextPC, _Component);
  function LongTextPC() {
    _classCallCheck(this, LongTextPC);
    return _possibleConstructorReturn(this, _getPrototypeOf(LongTextPC).apply(this, arguments));
  }
  _createClass(LongTextPC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      var required = question.required,
        type = question.type;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question.restrictions) || {};
      var openWordsRestriction = restrictions.openWordsRestriction;
      var content = function content(_ref) {
        var error = _ref.error,
          formAnswer = _ref.formAnswer,
          _onChange = _ref.onChange,
          placeholder = _ref.placeholder,
          _ref$maxWords = _ref.maxWords,
          maxWords = _ref$maxWords === void 0 ? 2000 : _ref$maxWords;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: required
        }, React.createElement(InputSingleLine, {
          value: formAnswer.text || '',
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          placeholder: placeholder,
          maxLength: openWordsRestriction ? maxWords : -1,
          maxwords: openWordsRestriction ? maxWords : -1,
          style: {
            minHeight: 80,
            marginTop: 0
          }
        }));
      };
      return /fillin/.test(type) ? React.createElement(FillinLong, this.props, content) : React.createElement(LongText, this.props, content);
    }
  }]);
  return LongTextPC;
}(Component);
export { LongTextPC as default };